import styled from 'styled-components';
import Icon from '@minecraft.icon';

export const Container = styled.div<{ $isExpanded: boolean }>`
  align-items: ${(props): string => (props.$isExpanded ? 'baseline' : 'center')};
  display: flex;
  border: 0.0625px solid ${(props): string => props.theme.filters.breadbox.borderColor};
  border-radius: 0.25rem;
  flex: auto;
  margin-left: 1rem;
  min-height: 2rem;
`;

export const PillList = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex: auto;
  margin: 0 4rem 0.25rem 0;

  & > * {
    margin: 0.25rem 0 0 0.25rem;
  }
`;

export const HiddenPillsCount = styled.div`
  align-self: center;
  margin-left: 0.5rem;
`;

export const ButtonGroup = styled.div`
  align-items: center;
  display: flex;

  & > * {
    padding: 0 0.25rem;
  }
`;

export const ExpandButton = styled.div`
  cursor: pointer;
`;

export const ExpandIcon = styled(Icon)`
  height: 1rem;
  width: 1rem;
`;
